export default __webpack_public_path__ + "static/media/meals_female.529336ef.png";